import { Button, Stack, Typography } from "@mui/material";
import { type FC, useState } from "react";
import type { PollRecipient } from "../context/moment-polls-context";
import { DisplayPersons } from "./display-person";

export const PollsNaughtyList: FC<{
  persons: PollRecipient[];
}> = ({ persons }) => {
  const [shown, setShown] = useState(false);

  return (
    <>
      <Stack direction="row" sx={{ marginBottom: 1, alignItems: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No response from
        </Typography>
        <Typography variant="body2" color="text.secondary" fontWeight={700} marginLeft={1}>
          {persons.length} recipient{persons.length === 1 ? "" : "s"}
        </Typography>
        <Button
          data-analytics-id="polls-show-naughty-list"
          variant="text"
          size="small"
          onClick={() => {
            setShown(!shown);
          }}
          sx={{ marginLeft: 1 }}
        >
          {shown ? "Hide" : "Show"}
        </Button>
      </Stack>
      {shown && <DisplayPersons persons={persons} />}
    </>
  );
};
